import { RequestConfig } from '@umijs/max';
import { message } from 'antd';
import { history } from '@umijs/max';
import { errorConfig } from './requestErrorConfig';
import { currentUser as queryCurrentUser } from './services/ant-design-pro/api';
import React from 'react';
import type { ProLayoutProps } from '@ant-design/pro-components';
import {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
} from '@/components';
import defaultSettings from '../config/defaultSettings';
import '@ant-design/v5-patch-for-react-19';

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  currentUser?: API.CurrentUser;
  userMenus?: API.MenuItem[];
  settings?: Partial<ProLayoutProps>;
  fetchUserInfo?: () => Promise<API.CurrentUser>;
}> {
  const fetchUserInfo = async () => {
    try {
      const currentUser = await queryCurrentUser();
      return {
        currentUser: currentUser.data as API.CurrentUser,
        userMenus: [],
        settings: defaultSettings,
        fetchUserInfo: async () => {
          const result = await queryCurrentUser();
          return result.data as API.CurrentUser;
        },
      };
    } catch (error) {
      console.error('获取用户信息失败:', error);
      return {
        settings: defaultSettings,
      };
    }
  };

  // 如果不是登录页面，执行
  const { location } = history;
  if (!['/user/login', '/user/register', '/user/register-result'].includes(location.pathname)) {
    return await fetchUserInfo();
  }
  
  return {
    settings: defaultSettings,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: any = ({ initialState, setInitialState }: any) => {
  console.log('🔍 [layout] initialState:', initialState);
  
  return {
    actionsRender: () => [
      <Question key="doc" />,
      <SelectLang key="SelectLang" />,
    ],
    collapsedButtonRender: () => null,
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_: any, avatarChildren: any) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.name,
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== '/user/login') {
        history.push('/user/login');
      }
    },
    bgLayoutImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    links: [],
    menuHeaderRender: undefined,
    // 确保菜单正常显示
    menu: {
      locale: true,  // 启用菜单国际化
    },
    // 其他配置...
    // rightContentRender: () => null, // 注释掉这行，让右上角头像正常显示
    onMenuHeaderClick: () => {
      history.push('/');
    },
    menuItemRender: (item: any, dom: any) => {
      if (item.path && item.path !== '/') {
        return <a onClick={() => history.push(item.path)}>{dom}</a>;
      }
      return dom;
    },
    // 自定义 403 页面
    // unAccessible: <MyAccessPage />,
    // 增加一个 loading 的状态
    childrenRender: (children: any) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
        </>
      );
    },
    ...initialState?.settings,
  };
};

// https://umijs.org/zh-CN/plugins/plugin-request
export const request: RequestConfig = {
  ...errorConfig,
};
